export const primaryFontList = `'Fira Sans', Arial, Helvetica, sans-serif`;
export const secondaryFontList = `'Fira Sans Condensed', Arial, Helvetica, sans-serif`;
export const tertiaryFontList = `'Fira Code', Courier, monospace`;

export const fontScale = {
  '-5': 0.555,
  '-4': 0.624,
  '-3': 0.702,
  '-2': 0.79,
  '-1': 0.889,
  0: 1,
  1: 1.125,
  2: 1.266,
  3: 1.424,
  4: 1.602,
  5: 1.802,
  6: 2.027,
  7: 2.281,
  8: 2.566,
  9: 2.887,
  10: 3.247,
  11: 3.652,
  12: 4.109,
};

export type FontScaleTypes = keyof typeof fontScale;

export default {
  primaryFontList,
  secondaryFontList,
  tertiaryFontList,
};
